import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import React from 'react';

import AuthLayout from '../../../Components/AuthLayout/AuthLayout';
import '../../LeadVettingPage/components/LeadVettingStyle.less';
import { trackEvent } from '../../LeadVettingPage/utils';

import styles from '../../LeadVettingPage/components/LeadVettingFormStyles.module.less';
import SignUpForm from './SignUpForm';

class SignUpPage extends React.Component {
  componentDidMount() {
    trackEvent('open', '');
  }

  render() {
    return (
      <AuthLayout wide>
        <div className={styles.leadVettingPageContainer}>
          <Helmet>
            <title>{gettext('Create account')}</title>
          </Helmet>
          <SignUpForm
            onSubmit={this.props.submitSignUpForm}
            isLoading={this.props.isLoading}
            product={this.props.product}
            error={this.props.error}
            fields={this.props.fields}
            updateFields={this.props.updateFields}
            prepopulatedFields={this.props.prepopulatedFields}
          />
        </div>
      </AuthLayout>
    );
  }
}

SignUpPage.propTypes = {
  submitSignUpForm: PropTypes.func,
  isLoading: PropTypes.bool,
  error: PropTypes.string,
  product: PropTypes.string,
  fields: PropTypes.object,
  updateFields: PropTypes.func,
  prepopulatedFields: PropTypes.object,
};

export default SignUpPage;
